import styles from './EmailDeliveryGuidance.module.css';

interface EmailDeliveryGuidanceProps {
  readonly className?: string;
}

/**
 * Standard guidance shown after the application reports that an email was sent.
 */
export function EmailDeliveryGuidance({
  className,
}: EmailDeliveryGuidanceProps): React.JSX.Element {
  const classes = [styles.guidance, className].filter(Boolean).join(' ');

  return (
    <p className={classes}>
      It may take a few minutes to arrive. If you do not see the message in your inbox, please
      check your spam or junk folder.
    </p>
  );
}
